import type { ObjectMetadata } from '@olytic/foundation';

import { formatMoney, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDate, asLabel, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['invoice-lines'];

/** One billing schedule row on an invoice. Rationale: invoice-lines.md. */
export const invoiceLines: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Invoice line',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('description', 'Description'),
    field('invoice_name', 'Invoice', { link: lookup('invoices', 'invoice_id') }),
    field('account_name', 'Account', { link: lookup('accounts', 'account_id') }),
    field('amount', 'Amount', { format: show(formatMoney) }),
    field('product_name', 'Product', { link: lookup('products', 'product_id') }),
    field('order_line_name', 'Order Line'),
    field('billing_schedule_name', 'Billing Schedule Row', { link: lookup('billing-schedules', 'billing_schedule_id') }),
    field('invoice_date', 'Invoice Date', { format: asDate }),
    field('invoice_status', 'Invoice Status', { format: asLabel }),
    field('sort_order', 'Order', { format: show((v) => formatNumber(v)) }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['description', 'invoice_name', 'account_name', 'amount', 'invoice_date', 'invoice_status'] },
    { key: 'source', label: 'What It Bills', fields: ['product_name', 'order_line_name', 'billing_schedule_name'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_by_name', 'last_modified_by_name', 'sort_order'] },
  ],
  related: [],
  titleOf: (row) => text(row.description),
  searchKeys: ['description', 'invoice_name', 'account_name'],
};
